export enum TextsListTaxonomy {
  SPEAKER = 'Comédien·ne',
  TRANSLATOR = 'Traducteur·rice',
}
